var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"to":{name:'chat'}},on:{"click":function($event){_vm.totalUnseen=0}}},[_c('feather-icon',{staticClass:"text-primary",attrs:{"size":"21","icon":"MessageSquareIcon","badge":_vm.totalUnseen,"badge-classes":"bg-danger"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }